import { ReactComponent as SpinnerIcon } from "../svgIcons/spinner-solid.svg";

const Spinner = () => (
    <div className="flex items-center justify-center w-full h-full">
        <SpinnerIcon className={"h-16 w-16 animate-spin text-red-700"} />
    </div>
);

export default Spinner;
